module.exports = __webpack_public_path__ + "img/bj.4c6ed084.png";